import { applyEntitySchema, objectSchema, optionalTolerant, sourceJson } from '../../_utils/fcdc-v2'
import * as z from 'zod'

const deviceSchema = objectSchema({
  handle: optionalTolerant(z.string()),
  appId: optionalTolerant(z.string()),
  build: optionalTolerant(z.number()),
  os: optionalTolerant(z.string()),
  osVer: optionalTolerant(z.string()),
  lang: optionalTolerant(z.string()),
})

export class Device {
  handle: string
  appId: string
  build: number
  os: string
  osVer: string
  lang: string

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.handle = source.handle
    this.appId = source.appId
    this.build = source.build
    this.os = source.os
    this.osVer = source.osVer
    this.lang = source.lang
    applyEntitySchema(this, deviceSchema, source, {})
  }
}
